import { mapState } from 'vuex';
export default {
  name: 'WidgetTypeSelector',
  props: {
    value: {
      type: String,
      required: false,
      default: 'chart'
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    widgetTypeOptions() {
      return [{
        text: this.$t('Dashboards.components.widgetTypeSelect.options.empty'),
        value: 'empty'
      }, {
        text: this.$t('Dashboards.components.widgetTypeSelect.options.chart'),
        value: 'chart'
      }, {
        text: this.$t('Dashboards.components.widgetTypeSelect.options.twinTable'),
        value: 'twin-table'
      }, {
        text: this.$t('Dashboards.components.widgetTypeSelect.options.twinMap'),
        value: 'twin-map'
      }];
    }
  }
};